import React from 'react';
import authorizedPaymentImg from '../assets/images/icon/pagoexitoso.gif'

function AuthorizedPayment({ orderReferenceNumber, urlRedirect, orderAmount }) {
  return (
    <div className="w-full flex flex-col items-center justify-center text-center lg:pl-[90px] lg:pr-[90px]">
        <img
            src={authorizedPaymentImg} alt="authorized"
            className="w-60 sm:w-52 md:w-80 lg:w-80 lg:h-80 object-contain"
        />

        <h1 className="txt-authorizing font-bold text-2xl mb-2 sm:text-2xl md:text-4xl lg:text-4xl -mt-[20px]">
            ¡Pago aprobado!
        </h1>
        <h2 className="text-gray-700 font-medium text-lg sm:text-xl mt-2">
            Tu número de pedido es <span id="orderReferenceNumber">{orderReferenceNumber}</span>
        </h2>

        <h2 className="text-gray-700 font-medium text-m sm:text-xl mt-2">
            Total: <span id="orderAmount">${Number(orderAmount).toFixed(2)}</span>
        </h2>

        <h3 className="text-gray-600 text-sm sm:text-base mt-[25px] pb-2">
            En 5 segundos automáticamente cambiará la página, si no lo hace, da clic{' '}
            <a id="urlRedirect" href={urlRedirect} className="text-[#B6BF00] font-semibold underline">
                aquí
            </a>
        </h3>
    </div>
  );
}

export default AuthorizedPayment;
